// Steps a landlord can ask tenants to complete. Keys match
// `tenant_requirements` on the landlord and workspace in the backend.
// `scope: "application"` is answered once per application;
// `scope: "person"` is done by every tenant and guarantor.
export const TENANT_REQUIREMENTS = [
  {
    key: "household",
    label: "Household and pets",
    shortLabel: "household and pets",
    description:
      "Adults, minors, pets and PPP dog. Answered once per application, by whoever shares first.",
    scope: "application",
    beforeSharingHint:
      "The application is not shared until this step is completed.",
  },
  {
    key: "client_identification",
    label: "KYC-AML identification form",
    shortLabel: "KYC-AML form",
    description:
      "Each tenant and guarantor signs their own. One signature per person for this landlord.",
    scope: "person",
    beforeSharingHint:
      "Only the person who shares must sign first. The other members always sign after sharing.",
  },
];

export const SCOPE_LABELS = {
  application: "Application level",
  person: "Person level",
};

export const normalizeTenantRequirements = (tenantRequirements = {}) =>
  Object.fromEntries(
    TENANT_REQUIREMENTS.map(({ key }) => {
      const active = tenantRequirements?.[key]?.active === true;
      return [
        key,
        {
          active,
          required_before_sharing:
            active &&
            tenantRequirements?.[key]?.required_before_sharing === true,
        },
      ];
    }),
  );

export const countActiveTenantRequirements = (tenantRequirements = {}) =>
  TENANT_REQUIREMENTS.filter(
    ({ key }) => tenantRequirements?.[key]?.active === true,
  ).length;
